<template>
  <div class="mc-delivery-tabs">
    <b-button
      v-for="tab in tabMappings"
      :key="tab.key"
      variant="light"
      :value="tab.key"
      :class="{ active: tab.key == activeTab }"
      :disabled="tab.isDisabled || isLoading"
      @click="handleClickTab"
    >
      {{ tab.name }}
    </b-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    status: {
      type: String,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
    visitedStatus: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:activeTab', 'showData'],
  computed: {
    ...mapState('delivery', ['shipmentType', 'activities']),
    isCancelAfterPickup() {
      const v = this.visitedStatus || []
      return v.includes('PICKED') && v.includes('CANCELED')
    },
    tabMappings() {
      const { activities } = this.$store.state.delivery
      const status = this.status

      const hasActivity = (type) =>
        activities?.some((activity) => activity.type === type && activity.status === 'COMPLETED')

      return [
        {
          key: 'INFORMATION',
          name: this.$t('delivery.title.detail'),
          isDisabled: false,
        },
        {
          key: 'PICKUP',
          name: this.$t('delivery.title.proofPicked'),
          isDisabled: this.isCancelAfterPickup
            ? false
            : !['Diambil', 'Sedang Transit', 'Terkirim'].includes(status) && !hasActivity('PICKUP'),
        },
        {
          key: 'DROP',
          name: this.$t('delivery.title.proofDelivered'),
          isDisabled: status !== 'Terkirim' && !hasActivity('DROP'),
        },
      ]
    },
  },
  methods: {
    async handleClickTab(e) {
      if (e.target.value == this.activeTab) return

      this.$emit('update:activeTab', e.target.value)
      if (e.target.value == 'INFORMATION') {
        await this.$store.dispatch('delivery/setActivities', [])
        this.$emit('showData')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-delivery-tabs {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  margin-bottom: 12px;

  & > button {
    height: 36px;
    flex-shrink: 0;
    color: $mep-color-text;
    font-weight: 500;
    transition: none;
    background: none;
    outline: none;
    border: none;
    border-radius: 4px;
    padding: 8px 20px;

    &:hover {
      background-color: $mep-secondary-100;
      color: $mep-color-text-400;
    }

    &:focus {
      outline: none;
    }

    &:disabled {
      color: #67718b;
    }
  }

  & > button.active {
    border: 1px solid $mep-primary;
    background-color: $mep-secondary-100;
    color: $mep-primary;
    font-weight: 600;
  }
}
</style>
